{
  "customAddress": "Enter custom address",
  "title": "<h1>Please confirm your address.</h1>",
  "subtitle": "<span>We could not proceed with the information you provided. Please use one of the suggested addresses below or enter a custom address.</span>",
  "select-option": "<span><strong>Please select an option:</strong></span>",
  "recommended": "(recommended)",
  "custom": "Enter custom address",
  "inputs": {
    "street_address": {
      "label": "Home Address",
      "isRequired": true,
      "showRequiredIcon": true,
      "validity": [
        ["required", "is required"],
        ["minLength2", "is invalid"],
        ["notEmail", "is invalid"],
        ["notPOBox", "PO Box is not accepted", "ignore label"]
      ]
    },
    "city": {
      "label": "City",
      "isRequired": true,
      "showRequiredIcon": true,
      "validity": [
        ["required", "is required"],
        ["minLength2", "is invalid"],
        ["notEmail", "is invalid"]
      ]
    },
    "region": {
      "label": "State",
      "isRequired": true,
      "showRequiredIcon": true,
      "placeholder": "Select a State",
      "validity": [
        ["required", "is required"],
        ["minLength2", "is invalid"],
        [
          "allowedRegionUS",
          "Unavailable for [value] residents",
          "ignore label"
        ],
        ["validRegionUS", "is invalid"]
      ]
    },
    "postal_code": {
      "label": "ZIP Code",
      "isRequired": true,
      "showRequiredIcon": true,
      "mask": "00000",
      "placeholder": "55555",
      "validity": [
        ["required", "is required"],
        ["minLength5", "is invalid"]
      ]
    }
  },
  "submit": "Continue"
}
